export const containers = {
  title: 'Containers',
  resourceName: 'Container',
  listTitle: 'Quản lý container',
  titles: {
    view: 'Chi tiết container',
    show: 'Xem container',
    edit: 'Chỉnh sửa container',
    create: 'Tạo container',
    list: 'Danh sách container',
    addQuick: 'Thêm nhanh',
  },
  messages: {
    noData: 'Không có dữ liệu',
    totalContainers: 'Tổng: {total} container',
    updateSuccess: 'Cập nhật container thành công',
    createSuccess: 'Tạo container thành công',
    errorGeneric: 'Có lỗi xảy ra',
    savedSuccess: 'Đã lưu thành công',
    saving: 'Đang lưu...',
    empty: 'Không có',
    emptyNotes: 'Không có ghi chú',
    emptyShippingLine: 'Không có hãng tàu',
    emptyShippingName: 'Không có tên tàu',
    emptyProductType: 'Không có loại sản phẩm',
    emptyCustomerName: 'Không có tên khách hàng',
    emptyCompanyName: 'Không có tên công ty',
    emptyAgency: 'Không có đại lý',
    emptySealCn: 'Không có mã niêm phong Trung Quốc',
    emptyDate: 'Không có ngày',
    selectShipments: 'Chọn lô hàng để xếp vào container',
    selectShipmentsTooltip: 'Chỉ có thể xếp lô đủ thông tin kích thước (Dài, Rộng, Cao, Cân nặng)',
    theSelectedShipments: 'Các lô hàng hiện tại đã được chọn',
    sortShipments: 'Sắp xếp thứ tự lên container',
    selectAndRemoveFromContainer: 'Chọn và bỏ khỏi container',
  },
  filter: {
    placeholder: 'Tìm theo mã container, mã tham chiếu...',
    advancedFilter: 'Lọc nâng cao',
    code: 'Mã container',
    refCode: 'Mã tham chiếu',
    status: 'Trạng thái',
    clearFilter: 'Xóa lọc',
    search: 'Tìm kiếm',
    all: 'Tất cả',
  },
  validation: {
    refCodeRequired: 'Vui lòng nhập mã tham chiếu',
    selectFromToWarehouse: 'Vui lòng chọn kho đi và kho đến',
    checkDates: 'Vui lòng kiểm tra lại ngày khởi hành, cập cảng và về kho',
    departureBeforeArrival: 'Ngày khởi hành phải trước hoặc bằng ngày cập cảng',
    arrivalBeforeReturn: 'Ngày cập cảng phải trước hoặc bằng ngày về kho',
    returnAfterDeparture: 'Ngày về kho phải sau hoặc bằng ngày khởi hành',
  },
  form: {
    codeAuto: 'Tự động tạo sau khi lưu',
    refCodePlaceholder: 'Nhập mã tham chiếu',
    productTypePlaceholder: 'Nhập loại sản phẩm',
    customerNamePlaceholder: 'Nhập tên khách hàng',
    fromWarehousePlaceholder: 'Kho xuất phát',
    toWarehousePlaceholder: 'Kho đích đến',
    fromPortPlaceholder: 'Nhập cảng đi',
    toPortPlaceholder: 'Nhập cảng đến',
    shippingLinePlaceholder: 'Nhập hãng tàu',
    shippingNamePlaceholder: 'Nhập tên tàu',
    companyNamePlaceholder: 'Nhập công ty đứng tên',
    agencyPlaceholder: 'Nhập đại lý',
    sealCnPlaceholder: 'Nhập mã niêm phong Trung Quốc',
    sealVnPlaceholder: 'Nhập mã niêm phong Việt Nam',
    notesOptional: 'Nhập ghi chú (tùy chọn)',
    departureDatePlaceholder: 'Ngày khởi hành',
    arrivalDatePlaceholder: 'Ngày cập cảng',
    returnDatePlaceholder: 'Ngày về kho',
  },
  fields: {
    code: 'Mã container',
    refCode: 'Mã tham chiếu',
    shippingMethod: 'Phương thức vận chuyển',
    closingDate: 'Ngày đóng',
    departureDate: 'Ngày khởi hành',
    arrivalDate: 'Ngày cập cảng',
    returnDate: 'Ngày về kho',
    deliveryDate: 'Ngày giao hàng',
    fromPort: 'Cảng đi',
    toPort: 'Cảng đến',
    status: 'Trạng thái',
    notes: 'Ghi chú',
    fromWarehouseId: 'Kho xuất phát',
    toWarehouseId: 'Kho đích đến',
    agency: 'Đại lý',
    sealCn: 'Mã niêm phong Trung Quốc',
    sealVn: 'Mã niêm phong Việt Nam',
    productType: 'Loại sản phẩm',
    customerName: 'Tên khách hàng',
    shippingLine: 'Hãng tàu',
    shippingName: 'Tên tàu',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    companyName: 'Công ty đứng tên',
    shipping: 'Thông tin vận chuyển',
    actions: 'Hành động',
    fromWarehouse: 'Kho đi',
    toWarehouse: 'Kho đến',
    shippingMethodShort: 'Phương thức',
  },
  fieldGroups: {
    basicInfo: 'Thông tin cơ bản',
    warehouseInfo: 'Thông tin kho hàng',
    shippingInfo: 'Thông tin vận chuyển',
    sealInfo: 'Thông tin niêm phong',
    additionalInfo: 'Thông tin bổ sung',
    scheduleInfo: 'Thông tin lịch trình',
  },
  searchCode: {
    label: 'Tìm theo mã hoặc mã tham chiếu',
    placeholder: 'Nhập mã container hoặc mã tham chiếu',
  },
  statuses: {
    NEW: 'Mới tạo',
    LOADING: 'Đang bốc hàng',
    CLOSED: 'Đã đóng cont',
    DEPARTED: 'Rời cảng',
    ARRIVED: 'Cập cảng',
    RETURNED: 'Đã về kho',
    UNLOADING: 'Đang dỡ hàng',
    DONE: 'Hoàn thành',
    DELETED: 'Xóa',
  },
  tabs: {
    overview: 'Tổng quan',
    listTheShipments: 'Danh sách lô hàng',
    listTheShipmentsTooltip: 'Chỉ có thể lên danh sách lô hàng cho container mới hoặc container đang bốc hàng',
    sealInfo: 'Thông tin niêm phong',
    shipmentsDraft: 'Đang đóng công',
    shipmentsClosed: 'Lô hàng (đã đóng cont)',
  },
  totals: {
    total: 'Tổng',
    weight: 'Tổng cân',
    volume: 'Tổng khối',
    shipments: 'Tổng lô',
    selectedShipments: 'Đã chọn',
  },
  buttons: {
    load: 'Xếp hàng',
    submit: 'Xác nhận',
    confirm: 'Xác nhận',
    save: 'Lưu',
  },
}
